import { POSTS_TYPE } from '@/app/components/shared/PostsModal/constants';
import type { SiteType } from '@/app/types';

export const resolveHomePostType = (site: SiteType, postType: POSTS_TYPE) => {
  if (site === 'china' && postType === POSTS_TYPE.REFERENCE) {
    return POSTS_TYPE.INSPIRATION;
  }

  return postType;
};
